import { Injectable } from "@angular/core";
import { sleep } from "src/app/functions/misc";
import { BackendService } from "src/app/services/common/backend.service";
import { HttpErrorHandlerService } from "src/app/services/common/http-error-handler.service";

export interface CheckoutStatusResponse {
  checkoutSessionStatus: "PENDING" | "PROCESSED" | "FAILED";
  packages: Array<{
    packageUuid: string;
    packageActivationCode: string;
  }>;
}

@Injectable({
  providedIn: 'root'
})
export class CheckoutStatusPoller {
  private readonly apiPath: string = "/api/public/checkout-status";

  constructor(
    private backendService: BackendService,
    private httpErrorHandlerService: HttpErrorHandlerService
  ) { }


  // timeoutMs időtartamaig folyamatosan próbálja lekérdezni a checkout állapotát
  // addig csinálja ameddig != PENDING, vagy a timeout lejárt
  public async checkStatus(checkoutId: string, options: { timeoutMs: number } = { timeoutMs: 20000 }): Promise<{ status: "TIMEOUT" | "PROCEED" | "FAILED" }> {
    let shouldRun = true;

    setTimeout(() => {
      shouldRun = false;
    }, options.timeoutMs);

    while (shouldRun) {
      try {
        const response: CheckoutStatusResponse = await this.backendService.callApi(`${this.apiPath}/${checkoutId}`, "GET");

        if (response.checkoutSessionStatus === "PROCESSED") {
          return { status: "PROCEED" };
        } else if (response.checkoutSessionStatus === "FAILED") {
          return { status: "FAILED" };
        }
      } catch (error: any) { }

      // If status is still PENDING, wait a bit before polling again
      await sleep(1000);
    }

    // If we've reached here, it means the timeout was reached
    return { status: "TIMEOUT" };
  }
}
